export default __webpack_public_path__ + "static/media/ISIL.cbc6e2f5.png";